module.exports = __webpack_public_path__ + "static/IMG_3026-f539bf97fff2773c3d121cf64b5bf6f7.jpg";